export enum AutomationActionError {
  EmptyNote = 'emptyNote',
  EmptyTags = 'emptyTags',
  EmptyTask = 'emptyTask',
  EmptyAssignTo = 'emptyAssignTo',
  EmptyFollowers = 'emptyFollowers',
  EmptyEvaluationForm = 'emptyEvaluationForm',
  EmptyEvaluationMembers = 'emptyEvaluationMembers',
  UserRoleError = 'userRoleError',
  EmptyEmailSubject = 'emptyEmailSubject',
  EmptyEmailBodyHtml = 'emptyEmailBodyHtml',
}
